import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';

// material
import { Tooltip, Stack, TextField, Typography, FormGroup, TextareaAutosize, FormControl, FormLabel, InputLabel, Select, MenuItem, Button, Grid, RadioGroup, Radio, FormHelperText, IconButton, Box } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TimePicker from '@mui/lab/TimePicker';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Moment from 'moment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { format } from 'date-fns';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
// -----------------------------------------------------------------------------------------------------


const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));


const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
//const stripHtml = (html) => {
//    if (!html) return "";

//    // Remove outer <p>...</p> only (Quill default)
//    html = html.replace(/^<p>|<\/p>$/g, "");

//    // Remove Quill empty line <p><br></p>
//    html = html.replace(/^<p><br><\/p>$/g, "");

//    return html.trim();
//};
const stripHtml = (html) => {
    if (!html) return "";

    const temp = document.createElement("div");
    temp.innerHTML = html;

    // Get only text content
    const text = temp.textContent || temp.innerText || "";

    return text.trim(); // returns "" if empty
};
export default function ServiceRequestBDTrackerDetails() {
    const location = useLocation();

    const { tracker, trackerMasterId, loadTrackerData, trackerName, isReopen } =
        location.state || {};   // <- read from state

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    // const productId = proMaster.ID;
    console.log("trackerId details>>", trackerMasterId, tracker, "loadTrackerData", loadTrackerData, "isReopen", isReopen)

    const [fieldValues, setFieldValues] = useState({});
    const [requestFile, setRequestFile] = useState([]);
    const [base64Document, setBase64Document] = useState([]); // New state for Base64 string
    const [validationErrors, setValidationErrors] = useState({});
    const [reopenPrefill, setReopenPrefill] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState(tracker.FileKeys || []);
    const [isLoading, setIsLoading] = useState();

    // executive ID
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [userId, setUserId] = useState([]);
    const [userName, setUserName] = useState('');

    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const [isTaskCompleted, setIsTaskCompleted] = useState(false);

    // Modal
    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate(`/dashboard/servicerequest/servicerequesttracker?trackerId=${trackerMasterId}`, { replace: true });

            setOpenModalCancel(false);
        }
        else {
            setOpenModalCancel(false);
        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);
    };

    const handleField = (sequence, value) => {
        // Update the field value in the state
        const finalValue = value === "@LoginUser" ? userName : value;

        setFieldValues(prevState => ({
            ...prevState,
            [sequence]: finalValue
        }));

        // Clear validation error for the field if value is entered
        if (validationErrors[sequence] && value.trim() !== '') {
            setValidationErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[sequence]; // Remove error for the specific field
                return updatedErrors;
            });
        }
    };

    const handleSelectFile = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const imagesArray = selectedFiles.map((file) => URL.createObjectURL(file));

        setRequestFile((prevImages) => [...prevImages, ...selectedFiles]);
        setUploadedFiles((prev) => [...prev, ...selectedFiles]); // ✅ prev will now be safe
        setBase64Document((prevFiles) => [...prevFiles, ...imagesArray]);

        event.target.value = ""; // Clear file input
        console.log("selectedFiles", selectedFiles);
    };

    const removeFile = (indexToRemove) => {
        setUploadedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
    };

    const handleTaskCompletedCheckBox = (event) => {
        setIsTaskCompleted(event.target.checked);
    };

    const renderField = (fields) => {
        const { UIControlKeyId, DisplayName, Sequence, DefaultValue, IsEdit, ColumnName, IsCompulsory } = fields;
        const dataValues = fields?.DataValues ?? "";

        // Get the preselected value from tracker[0] using the ColumnName
        const trackerData = tracker.DataTable?.[0] || []; // Ensure tracker[0] exists
        console.log("trackerData[ColumnName]:", trackerData[ColumnName]);

        const resolvedDefaultValue = DefaultValue === "@LoginUser" ? userName : DefaultValue;
        console.log("resolvedDefaultValue:", resolvedDefaultValue);

        const preSelectedValue = trackerData[ColumnName] || resolvedDefaultValue || '';

        console.log("preSelectedValue:", preSelectedValue);

        if (fieldValues[Sequence] === undefined && preSelectedValue) {
            console.log("Calling handleField with Sequence:", Sequence, "and value:", preSelectedValue);
            handleField(Sequence, preSelectedValue);
        }

        console.log("fieldValues[Sequence]:", fieldValues[Sequence]);
        // Error condition: if there is no field value and the preselected value is cleared
        // const hasError = IsCompulsory && (!fieldValues[Sequence] || fieldValues[Sequence].trim() === '');
        const hasError = IsCompulsory && (!fieldValues[Sequence] || stripHtml(fieldValues[Sequence]) === '');
        const errorMessage = hasError ? validationErrors[Sequence] : '';

        switch (UIControlKeyId) {
            case 1: // Label
                {
                    return (
                        <FormControl fullWidth margin="normal">
                            <InputLabel shrink>{DisplayName}</InputLabel>
                            <div>{preSelectedValue}</div>
                        </FormControl>
                    );
                }
            case 2: // TextField
                {
                    return (
                        <TextField
                            label={DisplayName}
                            fullWidth
                            size="small"
                            onChange={(e) => handleField(fields.Sequence, e.target.value)}
                            value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
                            disabled={!IsEdit}
                            error={!!errorMessage}
                            helperText={errorMessage}
                        />
                    );
                }
            case 3: // Dropdown/Select
                {

                    let options = [];

                    if (Array.isArray(dataValues)) {
                        // Case: DataValues is an array of { Id, Value }
                        options = dataValues.map(item => ({
                            id: item.Id,
                            name: item.Value
                        }));
                    } else if (typeof dataValues === "string" && dataValues.includes("Id:")) {
                        // Case: DataValues string with Id: and Name:
                        const regex = /Id:\s*(\d+),\s*Name:\s*([\w\s]+)/g;
                        const matches = Array.from(dataValues.matchAll(regex));
                        options = matches.map(match => ({
                            id: parseInt(match[1], 10),
                            name: match[2]
                        }));
                    } else if (typeof dataValues === "string") {
                        // Case: DataValues like [A|B|C]
                        const dataValuesMatch = dataValues.match(/\[([^[\]]+)\](?=[^[]*$)/);
                        options = dataValuesMatch
                            ? dataValuesMatch[1].split('|').map(value => ({ id: value, name: value }))
                            : [];
                    }

                    return (
                        <FormControl fullWidth
                            size="small"
                            error={!!errorMessage}
                        >
                            <InputLabel>{DisplayName}</InputLabel>
                            <Select
                                label={DisplayName}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                value={fieldValues[fields.Sequence] || preSelectedValue}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7',
                                            maxHeight: '200px',
                                            width: '200px',
                                        },
                                    },
                                }}
                                error={!!errorMessage}
                                disabled={!IsEdit}
                            >
                                {!IsCompulsory && <MenuItem key={0} value="">Select</MenuItem>}
                                {options.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errorMessage && <FormHelperText style={{ color: 'red' }}>
                                {errorMessage}
                            </FormHelperText>}
                        </FormControl>
                    );
                }
            case 4: // Radio Button
                {
                    let radioOptions = [];
                    const defaultRadioValue = preSelectedValue || 'No';

                    if (fields.DataValues) {
                        const cleanedDataValues = dataValues
                            .replace(/[{}]/g, '')
                            .split(',')
                            .map(option => option.trim())
                            .filter(option => option.length > 0);

                        cleanedDataValues.forEach(option => {
                            if (option.includes('No')) radioOptions.push('No');
                            if (option.includes('Yes')) radioOptions.push('Yes');
                            if (option === '[Yes|No]') radioOptions = ['Yes', 'No'];
                        });
                    }

                    return (
                        <FormControl component="fieldset" error={!!errorMessage}>
                            <FormLabel component="legend">{DisplayName}</FormLabel>
                            <RadioGroup
                                row
                                value={fieldValues[fields.Sequence] || defaultRadioValue}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                sx={{ flexDirection: 'row' }}
                                disabled={!IsEdit}
                            >
                                {radioOptions.map((option, index) => (
                                    <FormControlLabel
                                        key={`${fields.QuestionId}-${index}`}
                                        value={option}
                                        control={<Radio />}
                                        label={option}
                                        sx={{ marginRight: 2 }}
                                    />
                                ))}
                            </RadioGroup>
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );

                }
            case 5: // Checkbox
                {
                    const checkboxValue = fieldValues[fields.Sequence] ?? (preSelectedValue === 'true' || preSelectedValue === true);

                    return (
                        <FormControl error={!!errorMessage} component="fieldset">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={checkboxValue}
                                        onChange={(e) => handleField(fields.Sequence, e.target.checked)}
                                        color="primary"
                                        disabled={!IsEdit}
                                    />
                                }
                                label={DisplayName}
                            />
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>

                    );

                }
            case 6: // CheckBoxList
                {
                    // Parse DataValues for checkbox options
                    let checkboxOptions = [];
                    const selectedValues = fieldValues[fields.Sequence] || preSelectedValue || '';

                    if (fields.DataValues) {
                        // Extract checkbox options from DataValues (e.g., "Id: 1, Name: Option1|Id: 2, Name: Option2")
                        const regex = /Id:\s*(\d+),\s*Name:\s*([\w\s]+)/g;
                        const matches = Array.from(dataValues.matchAll(regex));
                        checkboxOptions = matches.map(match => ({
                            id: parseInt(match[1], 10),
                            name: match[2],
                            isChecked: selectedValues.includes(match[2]) // Check if the option is pre-selected
                        }));
                    }

                    // Handle change event for checkbox list
                    const handleCheckboxChange = (optionName, isChecked) => {
                        const updatedValues = selectedValues.split(',').filter(v => v); // Split and filter empty values
                        if (isChecked) {
                            // Add to the selected values if checked
                            if (!updatedValues.includes(optionName)) {
                                updatedValues.push(optionName);
                            }
                        } else {
                            // Remove from the selected values if unchecked
                            const index = updatedValues.indexOf(optionName);
                            if (index > -1) {
                                updatedValues.splice(index, 1);
                            }
                        }

                        // Join updated values back to a comma-separated string
                        handleField(fields.Sequence, updatedValues.join(','));
                    };

                    return (
                        <FormControl
                            component="fieldset"
                            error={!!errorMessage} // Error state
                        >
                            <FormLabel component="legend">{DisplayName}</FormLabel>
                            <FormGroup>
                                {checkboxOptions.map((option) => (
                                    <FormControlLabel
                                        key={option.id}
                                        control={
                                            <Checkbox
                                                checked={selectedValues.split(',').includes(option.name)}
                                                onChange={(e) => handleCheckboxChange(option.name, e.target.checked)}
                                                color="primary"
                                                disabled={!IsEdit}
                                            />
                                        }
                                        label={option.name}
                                    />
                                ))}
                            </FormGroup>
                            {/* Error message */}
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );
                }
            case 7: // Date Picker
                {
                    return (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label={DisplayName}
                                inputFormat="dd/MMM/yyyy"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        error={!!errorMessage} // Single source of error
                                        helperText={errorMessage} // Use only this for error message
                                    />
                                )}
                                onChange={(date) => {
                                    // Format the date or set to null if invalid
                                    const formattedDate = date ? format(date, 'dd-MMM-yyyy') : null;
                                    handleField(fields.Sequence, formattedDate);

                                    // Validate the date when selected
                                    if (IsCompulsory && !formattedDate) {
                                        validationErrors[fields.Sequence] = 'This field is required.';
                                    } else {
                                        validationErrors[fields.Sequence] = ''; // Reset error
                                    }
                                }}
                                value={fieldValues[fields.Sequence] || preSelectedValue || null} // Default or system date
                                disabled={!IsEdit}
                            />
                        </LocalizationProvider>
                    );
                }
            case 8: // Textarea
                {
                    return (
                        <FormControl fullWidth margin="normal" error={!!errorMessage}>
                            <TextareaAutosize
                                placeholder={DisplayName}
                                minRows={3}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
                                disabled={!IsEdit}
                                style={{
                                    width: "100%",
                                    height: "75px",
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    borderColor: errorMessage ? 'red' : '#c4c4c4', // Add red border if there's an error
                                    padding: '10px',
                                }}
                            />
                            {/* Display error message */}
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );
                }
            case 9: {
                const currentValue = fieldValues[fields.Sequence] ?? preSelectedValue ?? '';

                return (
                    <TextAreaWithToolbar
                        value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
                        //  onChange={(val) => handleField(fields.Sequence, val)}
                        onChange={(val) => {
                            const cleaned = stripHtml(val);
                            handleField(fields.Sequence, cleaned === "" ? "" : val);
                        }}
                        label={DisplayName}
                        errorMessage={errorMessage}
                        isEditable={IsEdit}
                        toolbarId={`toolbar-${fields.Sequence}`}
                    />

                );
            }


            default:
                return null;
        }
    };

    console.log("requestfile", requestFile, base64Document)
    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setUserName(CurrentLoggedInUser.ExecutiveName);
    }, []);

    const handleDownload = (fileKey, index) => {
        if (fileKey) {
            const encodedKey = encodeURIComponent(fileKey);
            URLS.downloadServiceFile(encodedKey, { responseType: 'blob' })
                .then((response) => {
                    const url = response.request.responseURL;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileKey.split('/').pop());
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    console.log(`Downloading: ${url}`);
                })
                .catch((error) => {
                    console.error('Download failed:', error);
                });
        } else {
            console.log('No fileKey provided for download.');
        }
    };

    useEffect(() => {
        if (isReopen === 1) {
            URLS.reopenValue({ Id: trackerMasterId })
                .then((response) => {
                    const data = response?.data;

                    if (Array.isArray(data) && data.length > 0) {
                        const prefill = {};
                        data.forEach((item) => {
                            const colName = item?.ColName;
                            const colValue = item?.ColValue;

                            if (colName && colValue !== undefined && colValue !== null && colValue !== "") {
                                prefill[colName] = colValue;
                            }
                        });
                        setReopenPrefill(prefill);
                    } else {
                        // clear or reset if data is invalid or empty
                        setReopenPrefill({});
                    }
                })
                .catch((error) => {
                    console.error("Failed to fetch reopen values:", error);
                    setReopenPrefill({});
                });
        } else {
            // clear when not reopen
            setReopenPrefill({});
        }
    }, [isReopen, trackerMasterId]);


    useEffect(() => {
        if (reopenPrefill && Object.keys(reopenPrefill).length > 0) {
            const updatedFields = { ...fieldValues };

            loadTrackerData.forEach(field => {
                const colName = field.ColumnName;
                const sequence = field.Sequence;

                // If reopen value exists for this column AND field is empty
                if (Object.prototype.hasOwnProperty.call(reopenPrefill, colName)) {
                    updatedFields[sequence] = reopenPrefill[colName];  // force override with reopenVal
                }
            });

            setFieldValues(updatedFields);
        }
    }, [reopenPrefill, loadTrackerData]);


    useEffect(() => {
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setUserName(CurrentLoggedInUser.ExecutiveName);

        // Preselect file from RefrenceDocument if available
        const referenceDocument = tracker?.DataTable?.[0]?.RefrenceDocument;
        if (referenceDocument) {
            // Split the reference document string by comma to get individual file names
            const fileNames = referenceDocument.split(',');

            // Initialize arrays for requestFile and base64Document
            const filesArray = [];
            const fileUrls = [];

            fileNames.forEach((fileName) => {
                // Create a File object for each file name
                const preselectedFile = new File([], fileName.trim(), {
                    type: 'text/plain', // Provide the MIME type if known (adjust based on file type)
                });

                // Add the File object to the files array
                filesArray.push(preselectedFile);

                // Create a URL for the file and add it to base64Document for preview (if needed)
                const preselectedFileUrl = URL.createObjectURL(preselectedFile);
                fileUrls.push(preselectedFileUrl);
            });

            // Set preselected files in the requestFile and base64Document states
            setRequestFile((prevFiles) => [...prevFiles, ...filesArray]);
            setBase64Document((prevFiles) => [...prevFiles, ...fileUrls]);
        }
    }, [tracker]);

    useEffect(() => {
        // Check for empty fields and update validation errors
        const newValidationErrors = {};
        loadTrackerData.forEach(field => {
            const value = fieldValues[field.Sequence];

            let valueToCheck = value ?? '';

            if (field.UIControlKeyId === 9) {
                valueToCheck = stripHtml(valueToCheck);
            }

            if (field.IsCompulsory && (!valueToCheck || valueToCheck.trim() === '')) {
                newValidationErrors[field.Sequence] = `${field.DisplayName} is required`;
            }
        });
        //if (requestFile.length === 0) {
        //    newValidationErrors.files = 'At least one file must be selected';
        //} else {
        //    // Clear the error when files are selected
        //    delete newValidationErrors.files;
        //}
        // Update validation errors state
        setValidationErrors(newValidationErrors);

    }, [fieldValues]); // Listen for changes in field values

    const formik = useFormik({
        initialValues: {

        },

        onSubmit: (values, actions) => {
            console.log("in>>>>");
            setIsLoading(true);
            const currentErrors = {};

            const QuestionAnswersData = loadTrackerData.map(field => {
                const fieldValue = fieldValues[field.Sequence];
                const preSelectedValue = tracker.DataTable?.[0][field.ColumnName] || field.DefaultValue || '';
                const resolvedDefaultValue = preSelectedValue === "@LoginUser" ? userName : preSelectedValue;

                // Check if field is required and not filled
                const showError = field.IsCompulsory && (!fieldValue || fieldValue === '' || !preSelectedValue);
                const isFieldEmpty = field.IsCompulsory && (!fieldValue || fieldValue.trim() === '');

                if (isFieldEmpty) {
                    currentErrors[field.Sequence] = `${field.DisplayName} is required`;
                }

                //if (showError) {
                //    validationErrors[field.Sequence] = `${field.DisplayName} is required`; // Store the error message for the specific field
                //}

                let finalValue;
                if (field.UIControlKeyId === 5) {
                    finalValue = fieldValue === true ? "True" : "False";
                }
                else if (field.UIControlKeyId === 7) {
                    finalValue = fieldValue || resolvedDefaultValue || format(new Date(), 'dd-MMM-yyyy');
                }
                else {
                    // Other controls
                    finalValue = fieldValue !== undefined ? fieldValue : (resolvedDefaultValue ?? field.Answers ?? '');
                }

                // Remove HTML for Rich Text / HTML control
                if (field.UIControlKeyId === 9) {
                    finalValue = stripHtml(finalValue);
                }

                //if (field.UIControlKeyId === 7) { // Check if it's a DatePicker
                //    finalValue = fieldValue || resolvedDefaultValue || format(new Date(), 'dd-MMM-yyyy'); // Default to system date if empty
                //} else {
                //    finalValue = fieldValue !== undefined ? fieldValue : (resolvedDefaultValue ?? field.Answers ?? '');

                //}
                //if (field.UIControlKeyId === 9) {
                //    finalValue = stripHtml(finalValue);       // <-- REMOVE default <p>
                //}

                return {
                    ColumnName: field.ColumnName,
                    Value: finalValue,
                };
            });

            if (JSON.stringify(currentErrors) !== JSON.stringify(validationErrors)) {
                setValidationErrors(currentErrors);
            }

            // **Stop form submission if there are validation errors**
            if (Object.keys(currentErrors).length > 0) {
                console.log("Form has validation errors:", currentErrors);
                return;
            }

            const currentId = tracker?.DataTable?.[0]?.ID || 0;
            // Proceed with form submission if no errors
            const formData = new FormData();
            // formData.append("Id", Number(isReopen) === 1 ? 0 : currentId);
            formData.append("Id", currentId);
            formData.append("LoginId", userId);
            // formData.append("ServiceRequestId", Number(isReopen) === 1 ? 0 : (tracker?.DataTable?.[0]?.ServiceRequestId || 0)) ;
            formData.append("ServiceRequestId", tracker?.DataTable?.[0]?.ServiceRequestId || 0);
            formData.append("Request", "");
            formData.append("ServiceRequestMappingColumn", "");
            formData.append("RefrenceDocument", "");
            formData.append("TrackerMasterId", trackerMasterId);
            formData.append("IsReopen", isReopen || 0);
            formData.append("OldIncidentId", Number(isReopen) === 1 ? currentId : 0);
            formData.append("IsResolvedBySupportTeam", 1);
            

            for (let i = 0; i < requestFile.length; i += 1) {
                formData.append("RequestDocument", requestFile[i]);
            }
            if (uploadedFiles?.length > 0) {
                // Filter only strings (existing file paths)
                const existingFileNames = uploadedFiles
                    .filter(file => typeof file === 'string')
                    .map(filePath => filePath.split('/').pop()) // extract filename
                    .join(','); // comma-separated
                if (existingFileNames) {
                    formData.append("ExistingFiles", existingFileNames);
                }
            }


            QuestionAnswersData.forEach((item, index) => {
                formData.append(`TrackerData[${index}].ColumnName`, item.ColumnName);
                formData.append(`TrackerData[${index}].Value`, item.Value);
            });

            URLS.saveIssueTrackerData(formData)
                .then((response) => {
                    if (response.data) {
                        setIsLoading(false);

                        enqueueSnackbar("Record saved successfully", { variant: 'success' });
                        navigate(`/dashboard/servicerequest/servicerequesttracker?trackerId=${trackerMasterId}`, { replace: true });
                        console.log("+++++++++++++++++++++++++++++++++++++", trackerMasterId, `/dashboard/servicerequest/servicerequesttracker?trackerId=${trackerMasterId}`, tracker)
                    }
                })
                .catch(error => {
                    setIsLoading(false);
                    enqueueSnackbar("Record not saved", { variant: 'error' });
                });

            console.log("payload", formData);
        },

    });
    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

    return (
        <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Stack spacing={4}>

                    <Grid container spacing={2}>
                        {loadTrackerData.map((item, index) => (
                            // Check if the current item's UIControlKeyId is 8 (textarea control) and UIControlKeyId is 9 (textEditor control)
                            [8, 9].includes(item.UIControlKeyId) ? (
                                <Grid item xs={12} key={index}>
                                    {renderField(item)}
                                </Grid>
                            ) : (
                                <Grid item xs={4} key={index}>
                                    {renderField(item)}
                                </Grid>
                            )
                        ))}
                    </Grid>

                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Button
                            component="label"
                            variant="contained"
                            tabIndex={-1}
                            sx={{
                                height: 25,
                                width: 130,
                                borderRadius: 1,
                                fontWeight: 500,
                                ":hover": { backgroundColor: "#9e9e9e" },
                                backgroundColor: "#e0e0e0",
                                color: "#212121",
                                boxShadow: "none",
                            }}
                        >
                            Choose Files
                            <VisuallyHiddenInput type="file" onChange={(e) => handleSelectFile(e)} multiple />
                        </Button>

                        {/*<FormGroup>*/}
                        {/*    <FormControlLabel*/}
                        {/*        sx={{ m: 0 }}*/}
                        {/*        control={*/}
                        {/*            <Checkbox*/}
                        {/*                checked={isTaskCompleted}*/}
                        {/*                onChange={handleTaskCompletedCheckBox}*/}
                        {/*                icon={*/}
                        {/*                    <Box*/}
                        {/*                        sx={{*/}
                        {/*                            width: 18,*/}
                        {/*                            height: 18,*/}
                        {/*                            border: '1px solid #D1D5DB',*/}
                        {/*                            borderRadius: '4px',*/}
                        {/*                        }}*/}
                        {/*                    />*/}
                        {/*                }*/}
                        {/*                checkedIcon={*/}
                        {/*                    <Box*/}
                        {/*                        sx={{*/}
                        {/*                            width: 18,*/}
                        {/*                            height: 18,*/}
                        {/*                            border: '1px solid #D1D5DB',*/}
                        {/*                            borderRadius: '4px',*/}
                        {/*                            backgroundColor: '#1976d2',*/}
                        {/*                            display: 'flex',*/}
                        {/*                            alignItems: 'center',*/}
                        {/*                            justifyContent: 'center',*/}
                        {/*                            color: '#fff',*/}
                        {/*                            fontSize: 14,*/}
                        {/*                        }}*/}
                        {/*                    >*/}
                        {/*                        ✓*/}
                        {/*                    </Box>*/}
                        {/*                }*/}
                        {/*            />*/}
                        {/*        }*/}
                        {/*        label="Resolved By Support Team."*/}
                        {/*    />*/}
                        {/*</FormGroup>*/}

                         {validationErrors.files && ( 
                            <Typography variant="body2" color="error" sx={{ marginTop: 1 }}> 
                                {validationErrors.files} 
                            </Typography> 
                         )} 

                        {/* {!validationErrors.files && ( */}
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            flexWrap="wrap"
                            sx={{ maxWidth: 'calc(100% - 150px)' }}
                        >
                            {uploadedFiles?.map((fileItem, index) => {
                                const isFileObject = fileItem instanceof File;
                                const fileName = isFileObject
                                    ? fileItem.name
                                    : fileItem?.split('/').pop()?.trim().replace(/^\d+_/, '');

                                return (
                                    <Stack
                                        key={index}
                                        direction="row"
                                        alignItems="center"
                                        sx={{
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: 1,
                                            padding: '0 8px',
                                            marginRight: 1,
                                            maxWidth: 200,
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Tooltip title={fileName} >
                                            <a
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (isFileObject) {
                                                        const url = URL.createObjectURL(fileItem);
                                                        const link = document.createElement('a');
                                                        link.href = url;
                                                        link.setAttribute('download', fileItem.name);
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                        URL.revokeObjectURL(url);
                                                    } else {
                                                        handleDownload(fileItem); // fileItem is a string (FileKey)
                                                    }
                                                }}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: '#1976d2',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>
                                                    {fileName}
                                                </Typography>
                                            </a>
                                        </Tooltip>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                const updated = [...uploadedFiles];
                                                updated.splice(index, 1);
                                                setUploadedFiles(updated);
                                            }}
                                            sx={{ padding: 0 }}
                                        >
                                            <Iconify icon="mdi:close" />
                                        </IconButton>
                                    </Stack>
                                );
                            })}

                        </Stack>


                        {/* )} */}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" spacing={2} mt={4}>
                        <LoadingButton
                            size="medium"
                            type="submit"
                            variant="contained"
                            sx={{ color: 'white' }}
                            loading={isLoading}
                            disabled={Object.keys(validationErrors).length > 0}
                        >
                            Save
                        </LoadingButton>

                        <Button
                            sx={{ color: 'white' }}
                            onClick={handelCancelClick}
                            size="medium"
                            variant="contained"
                            color="primary"
                        >
                            Cancel
                        </Button>
                    </Stack>
                </Stack>

                {openModalForCancel && (
                    <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />
                )}
            </Form>
        </FormikProvider>
    );

}